module.exports = __webpack_public_path__ + "img/img_body_biz_chunmyung_logo.15da550b.png";